module.exports = __webpack_public_path__ + "img/11_6.b7c33278.png";